import { useStore } from "@/store";

export function useIsPublishedDoc() {
  const { doc, documentTree, publicProfile } = useStore();
  if (!doc?.id) {
    return false;
  }
  return documentTree.findFileInTree(publicProfile.published?.files || [], doc.id);
}
